export default __webpack_public_path__ + "static/media/about-us.11525292.jpg";